'use client'

import { useEffect } from 'react'

import useTracking from '../hooks/useTracking'

type Props = {
  event: string
  params: Record<string, unknown>
}
export default function AnonymousTracker({ event, params }: Props) {
  const { track } = useTracking(undefined, undefined, {
    waitForUser: true,
    withUser: false,
  })

  useEffect(() => {
    track?.(event, params)
  }, [event, params, track])

  return false
}
